import { Container, Pill } from '@mantine/core';
import { ROOT_SOURCE } from 'shared-base';
import GeneratorInfo from '../GeneratorInfo/GeneratorInfo';
import LoaderPage from '../LoaderPage/LoaderPage';
import MarkdownRemote from '../Markdown/Markdown.remote';
import { Column, Mark, Row, Story, Tags, Wrapper } from './GeneratorDetails.style';
import { parser } from './GeneratorDetails.utils';

export type GeneratorDetailsProps = {
  generator: IGenerator;
  children?: React.ReactNode;
  onOpenInPlayground: (id: string) => void;
};

export function GeneratorDetails(props: GeneratorDetailsProps) {
  const { generator } = props;

  if (!generator)
    return (
      <Wrapper>
        <LoaderPage />
      </Wrapper>
    );

  const { tags = [] } = generator;

  // const items = [
  //   { id: 'generators', title: 'generators', path: '/generators' },
  //   { id: generator.id, title: generator.id, path: `/generators/${generator.id}` },
  // ];

  function renderTags() {
    return tags.map((tag: string, index) => (
      <Pill key={index} className='pill'>
        {tag}
      </Pill>
    ));
  }

  return (
    <Wrapper className='GeneratorDetails-wrapper' data-testid='GeneratorDetails-wrapper'>
      <Container size='lg'>
        {/* <Top>
          <BreadCrumbs items={items} />
        </Top> */}
        <Row>
          <Column>
            <GeneratorInfo generator={generator} onOpenInPlayground={props.onOpenInPlayground} />
            <Tags>{renderTags()}</Tags>
          </Column>
          <Column>
            {props.children}
            <Story>
              <Mark>
                <MarkdownRemote
                  parser={parser}
                  mode='dark'
                  url={`${ROOT_SOURCE}/${generator.id}.story.md?15`}
                />
              </Mark>
              {/* <Permutations /> */}
            </Story>
          </Column>
        </Row>
      </Container>
    </Wrapper>
  );
}

export default GeneratorDetails;
